<template>
  <div>
    <div>
      <!-- Título -->
      <div class="my-4 text-h6 text-center">Nota Geral</div>

      <!-- Tabela -->
      <v-data-table dense :headers="headers" :items="avaliacaoGeralDados" class="elevation-1 mb-6" hide-default-footer>

        <!-- Acrescenta caixas coloridas no cabeçalho -->
        <!-- Os slots dinâmicos do vuetify tem uma incompatibilidade com o eslint, por isso as linhas comentadas a seguir. (está na documentação do vuetify) -->
        <!-- eslint-disable-next-line -->
        <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }" >
          <!-- eslint-disable-next-line -->
          <th style="display: inline-flex; align-items: center; justify-items: center;">
            <span v-if="header.value !== 'Total' && header.value !== 'Média'" class="tamanhoDoQuadrado"
              :style="{color: header.color}">&#9632;</span><span>{{ header.text }}</span>
          </th>
        </template>

        <!-- Dados das Avaliações -->
        <!-- eslint-disable-next-line  -->
        <template v-slot:item="{ item }">
          <!-- eslint-disable-next-line  -->
          <tr>
            <!-- eslint-disable-next-line  -->
            <td v-for="i in item" style="border-bottom: none;">
              <!-- eslint-disable-next-line  -->
              <span>{{ i }}</span>
            </td>
          </tr>

          <!-- Acrescenta gráfico na linha -->
          <!-- eslint-disable-next-line  -->
          <tr>
            <!-- Colocar no colspan o número de avaliações menos o total e a media. x-2 ou x -->
            <td :colspan="headers.length-2" style="text-align: center; height: 15px;">
              <div id="chart" style="margin-bottom: 10px; margin-top: -5px">
                <apexchart type="bar" height="10" :options="chartOptions" :series="graficoDados"></apexchart>
              </div>
            </td>
          </tr>
        </template>

      </v-data-table>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import {
    mapGetters
  } from 'vuex'

  import {
    registerVuexModule
  } from '@/utils/vuexUtils'

  import relatoriosPesquisaSatisfacaoStore from '../../../store'

  export default {
    props: {
      valores: Array,
      labels: Array,
      notasTotal: Object,
      idFila: String,
    },
    components: {
      apexchart: VueApexCharts,
    },

    data: () => ({
      chartOptions: {
        chart: {
          type: 'bar',
          height: 10,
          stacked: true,
          stackType: '100%',
          sparkline: {
            enabled: true
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        yaxis: {
          show: false,
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false,
          },
        },
        xaxis: {
          show: false,
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          },
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
        }
      },
      // FIM APEX
      headers: [],
      metricasPesquisa: [],
      cores: [],
    }),

    methods: {
      mapLabels() {
          this.labels.forEach((label, key) => {
            if (typeof this.headers[key] === 'undefined') {
              this.headers[key] = {}
            } 
            this.headers[key].text = label
            this.headers[key].value = label
            if (this.headers[key].value == "Total" || this.headers[key].value == "Média") {
              this.headers[key].color = "#FFF"
            } else if (this.headers[key].value == "Inválida") {
              this.headers[key].color = this.cores[key] = "#717171"
            } else {
              this.headers[key].color = this.cores[key]
            }
          })
      },
    },

    computed: {
      ...mapGetters('relatoriosPesquisaSatisfacaoStore', ['findPesquisaById']),
      avaliacaoGeralDados() {
        let avaliacaoGeralDados = []
        let dados = {}

        for (let i = 0; i < this.valores.length; i++) {
          let valorEmPorcentagem = 0

          if (this.labels[i] === 'Média' || this.labels[i] === 'Total') {
            dados[this.labels[i]] = `${this.valores[i]}`
          } else {
            if (this.valores[i].amount > 0) {
              valorEmPorcentagem = (Math.round(((this.valores[i].amount) / this.notasTotal.Total) * 100) * 10) / 10
            } else {
              valorEmPorcentagem = 0
            }
            dados[this.labels[i]] = `${this.valores[i].amount} (${valorEmPorcentagem})%`
          }
        }
        avaliacaoGeralDados.push(dados)

        return avaliacaoGeralDados
      },

      graficoDados() {
        let dados = []

        for (let i = 0; i < this.labels.length; i++) {
          let name = ''
          let data = 0
          let color = ''
          let dado = {}

          if (this.labels[i] !== 'Média' && this.labels[i] !== 'Total') {
            name = `${this.labels[i]}`
            data = this.valores[i].amount
            color = `${this.cores[i]}`

            dado = {
              name,
              "data": [data],
              color
            }
            dados.push(dado)
          } else {
            if (this.labels[i] === 'Média' && this.labels[i] === 'Total') {
              name = `${this.labels[i]}`
              data = this.valores[i]
              color = `${this.cores[i]}`

              dado = {
                name,
                "data": [data],
                color
              }
              dados.push(dado)
            }
          }
        }

        return dados
      }

    },

    async created() {
      registerVuexModule(this.$store, 'relatoriosPesquisaSatisfacaoStore', relatoriosPesquisaSatisfacaoStore)

      // CORES
      const pesquisa = this.findPesquisaById(this.idFila)
      const metricasPesquisa = Object.values(pesquisa.metricas)

      this.cores = metricasPesquisa.map(metrica => metrica.color)
      
      this.mapLabels()
      // FIM CORES
    },

  //   watch: {

  //     labels: {
  //       deep: true,
  //       immediate: true,
  //       handler() {
  //         this.labels.forEach((label, key) => {
  //           if (typeof this.headers[key] === 'undefined') {
  //             this.headers[key] = {}
  //           } 
  //           this.headers[key].text = label
  //           this.headers[key].value = label
  //           if (this.headers[key].value == "Total" || this.headers[key].value == "Média") {
  //             this.headers[key].color = "#FFF"
  //           } else if (this.headers[key].value == "Inválida") {
  //             this.headers[key].color = this.cores[key] = "#717171"
  //           } else {
  //             this.headers[key].color = this.cores[key]
  //           }
  //         })
  //       },
  //     },
  //   },
  }
</script>
<style lang="scss" scoped>
  tbody {
    tr:hover {
      background-color: transparent !important;
    }
  }

  .tamanhoDoQuadrado {
    font-size: 35px;
  }
</style>